import { Component, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { SvTableHeaderItem, PageChange, SvDefaultTableHeaderItem, SvSortDirection, SvTableHeaderChanged, SvNotificationStatus } from 'sv-chemistry-ng-lib';
import { CheckboxListItem, CheckboxItem } from 'sv-chemistry-ng-lib';
import { TableHelper } from 'src/app/shared/util/table-helper';
import { Order, PageOrder } from 'src/app/models/order';
import { OrderService } from "src/app/core/services/order.service";
import { saveAs } from 'file-saver';
import { UserInfoService } from 'src/app/core/services/user-info.service';
import { Retailer } from 'src/app/models/Retailer';
import { PageLevelNotificationService, SvNotification } from 'src/app/core/services/page-level-notification.service';
import { Store } from 'src/app/models/store';
import { environment } from 'src/environments/environment';
import { EndpointError } from 'src/app/models/EndpointError';

@Component({
  selector: 'order-table',
  templateUrl: './order-table.component.html',
  styleUrls: ['./order-table.component.scss']
})
export class OrderTableComponent implements OnInit {
  userNotFound = false;
  isSessionTimeOut = false;

  allOrders: PageOrder[] = [];
  ordersPageView: PageOrder[] = [];
  tableHelper: TableHelper = new TableHelper();
  findItemsCurrentPage: PageChange;
  isSelectAllSelected: boolean = false;

  orderDayLimit: number;
  showDownloadLoading: boolean = false;
  showDownloadErrorMessage: boolean = false;
  downloadErrorMessage: string = "download error of some kind";

  selectedOrderId: any;
  selectedRetailCompany: Retailer = null;

  constructor(private _userService: UserInfoService, private _orderService: OrderService, private _pageNotificationService: PageLevelNotificationService) { }

  ngOnInit() {
    this._userService.selectedRetailCompany$.subscribe(rc => {
      this._orderService.getNoOfDaysToDisplayOrders().subscribe(res => {
        this.orderDayLimit = res['defaultPreviousOrderDays'];
        this.selectedRetailCompany = rc;
        if (this.selectedRetailCompany && this.selectedRetailCompany != null) {
          this.getOrdersForStores(this.selectedRetailCompany.stores, this.orderDayLimit);
        }
      },
      error => {
        this.showErrorNotification(error,"We are recieving an error while trying to retrieve the Previous Order Days");
      });
    },
    error => {
      this.showErrorNotification(error, "We are experiencing an error while retrieving the selected retail company");
   });

    this.setupHeaders();
  }

  convertOrdersToPageOrders(orders: Order[]): PageOrder[] {
    let retVal: PageOrder[] = [];
    retVal = orders.map((order) => {
      return this.convertOrderToPageOrder(order);
    })
    return retVal;
  }

  convertOrderToPageOrder(order: Order): PageOrder {
    let retOrder = new PageOrder();

    Object.keys(order).forEach((key) => {
      retOrder[key] = order[key];
    })
    return retOrder;
  }

  getOrdersForStores(stores: Store[], showDays : number) {
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    } else {
      this._orderService.getOrderDetailsForStore(stores,showDays).subscribe(data => {

        data.forEach(row => {
          if (!row.selectionCheckbox) {
            row.selectionCheckbox = new CheckboxItem(false);
          }
        });
        this.allOrders = this.convertOrdersToPageOrders(data);
        this.allOrders.sort(function(a,b){
          return b.transmissionDate == a.transmissionDate? 0 : b.transmissionDate < a.transmissionDate ? -1 : 1;
        });

        this.changePage(this.findItemsCurrentPage, this.allOrders);
      },
      error => {
        this.showErrorNotification(error, "We are exeperiencing a problem while retrieving orders");
      });
    }
  }

  private setupHeaders() {
    let headerNames = ["File Name", "Status", "Transmitted", "Delivery Date"];
    //    transmitDate : Date;
    let headerColCodes = ["fileName", "status", "transmissionDate", "deliveryDate"];

    let headers: SvTableHeaderItem[] = [];
    headerNames.forEach((name, index) => {
      let currentHeader: SvTableHeaderItem = new SvDefaultTableHeaderItem(name, index);
      currentHeader.isSortable = true;
      currentHeader.isAbleToBeHidden = false;
      currentHeader.isShown = true;
      currentHeader.columnCode = headerColCodes[index];
      headers.push(currentHeader);
    })
    this.tableHelper.setTableHeaders(headers);
  }

  changePage(pageInfo: PageChange, data: Array<PageOrder>): void {
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    } else {
      this.findItemsCurrentPage = pageInfo;
      setTimeout(() => {
        if (this.findItemsCurrentPage !== null && this.findItemsCurrentPage !== undefined) {
          this.ordersPageView = data.slice(this.findItemsCurrentPage.startingRecord, this.findItemsCurrentPage.endingRecord + 1);
          for (let i = 0; i < this.ordersPageView.length; i++) {
            if (!this.ordersPageView[i].selectionCheckbox.isSelected) {
              this.isSelectAllSelected = false;
              break;
            } else {
              this.isSelectAllSelected = true;
            }
          }
        }
      })
    }

  }

  handleSort(changes: SvTableHeaderChanged) {
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    } else {
      if (changes) {
        let changedHeader = changes.changed;
        if (changedHeader.isSortable && changedHeader.sortDirection !== SvSortDirection.None) {
          this.allOrders.sort((a, b) => {
            // assume ascending
            let retVal = (a[changedHeader.columnCode] + "").toString().localeCompare((b[changedHeader.columnCode] + "").toString());
            if (changedHeader.sortDirection === SvSortDirection.Desc && retVal) {
              retVal = -retVal;
            }
            return retVal;
          });
        }
        this.changePage(this.findItemsCurrentPage, this.allOrders);
      }
    }
  }

  checkAllItems(isChecked: boolean): void {
    this.ordersPageView.forEach(row => {
      if (row.selectionCheckbox) {
        row.selectionCheckbox.isSelected = isChecked;
      }
    })
  }

  orderChecked(orderChanged: CheckboxItem, passedOrderId : number) {
    this.isSelectAllSelected = true;
    for (let i = 0; i < this.ordersPageView.length; i++) {
      if (!this.ordersPageView[i].selectionCheckbox.isSelected) {
        this.isSelectAllSelected = false;
        break;
      }
    }
    for (let i = 0; i < this.allOrders.length; i++) {
      if (this.allOrders[i].orderId == passedOrderId) {
        this.allOrders[i].selectionCheckbox.isSelected = orderChanged.isSelected;
        break;
      }
    }
  }

  isOrderChecked(): boolean {
    let retVal: boolean = false;
    if (this.ordersPageView && this.ordersPageView.length > 0) {
      this.ordersPageView.forEach(row => {
        if (row.selectionCheckbox && row.selectionCheckbox.isSelected) {
          retVal = true;
        }
      })
    }
    return retVal;
  }

  downloadClicked() {
    if(this._userService.isTimeout()) {
      this.userNotFound = true;
      this.isSessionTimeOut = true;
    } else {
      this.showDownloadLoading = true;

      if (this.allOrders.length !== 0) {
        for (let i = 0; i < this.allOrders.length; i++) {
          if(this.allOrders[i].selectionCheckbox.isSelected) {
            this._orderService.getOrderDetailsFile(this.allOrders[i].orderId).subscribe(response => {
              const contentDispositionHeader: string = response.headers.get('Content-Disposition');
              const parts: string[] = contentDispositionHeader.split(';');
              const filename = parts[1].split('=')[1];
              const blob = new Blob([response._body], { type: 'text/ord' });
              saveAs(blob, filename);
              this.allOrders[i]['downloaded'] = true;
              this.allOrders[i].selectionCheckbox.isSelected = false;
            },
              error => {
               this.showErrorNotification(error, "We are experiencing problems while retreiving orders for stores");
              }
            );
          }
        }
      } else {
        this.downloadErrorMessage = "Please select at least one order to download.";
        this.showDownloadErrorMessage = true;
      }
      this.showDownloadLoading = false;
    }
  }

  returnToLogin() {
    window.location.href = environment.guardLoginUrl;
  }

  showErrorNotification(error : any, genericeMessage : string = null) {
  console.log(error);
    let errorMessage = null;
    if(error._body) {
      let returnedError = JSON.parse(error._body);
      errorMessage = returnedError.details;
    } else if(error.error) {
      errorMessage = error.error.details + ". " + error.error.message;
    }else if(error.status == 401) {
      this.userNotFound = true;
    } else {
      errorMessage = genericeMessage != null ? genericeMessage : "We are experiencing order issues.. Please try again.";
    }
    if(errorMessage != null) {
      this._pageNotificationService.showNotification(new SvNotification(SvNotificationStatus.Error,errorMessage ));
    }
  }
}
